import * as React from 'react';
import { get } from 'lodash';
import { compose, withHandlers } from 'recompose';
import { reduxForm } from 'redux-form';
import { Row, Col, Grid } from 'react-flexbox-grid';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';
import { forwardedSoDelict } from '@modules/delicts/_delictsActions';
import { withNotifications } from '@components/hoc/withNotifications';

const enhance = compose<any, any>(
  withNotifications({ forwardedSoDelict }),
  withHandlers({
    onSubmit: ({ reloadDelict, delictId, closeItem, forwardedSoDelictNotify }) => async formData => {
      const result = await forwardedSoDelictNotify({ id: delictId, ...formData });
      if (result) {
        await reloadDelict();
        closeItem();
      }
    }
  }),
  reduxForm({ form: 'module-events-delicts-forwarded-so' })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <h4>Předat na SO</h4>
              </Col>
            </Row>
            <Row>
              {[
                {
                  name: 'employeeId',
                  label: 'Strážník',
                  url: '/metropolis/api/hr/employees',
                  labelFunction: o => get(o, 'fullName')
                },
                {
                  name: 'resolutionSoId',
                  label: 'Správní Orgán ',
                  url: '/metropolis/api/ed/delict/resolution-sos',
                  labelFunction: o => get(o, 'name')
                }
              ].map(field => (
                <Col md={12}>
                  <RemoteAutoCompleteField
                    component={RemoteAutoComplete}
                    valueFunction={o => get(o, 'id')}
                    fullWidth={true}
                    {...field}
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
        <Button label="Uložit a zavřít" primary={true} type={'submit'} style={{ margin: '8px' }} />
        <Button label="Zrušit" style={{ margin: '8px' }} onClick={closeItem} />
      </Grid>
    </form>
  </div>
);

export const EventsFormDelictsForwardedSoForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormDelictsForwardedSoForm.tsx